import { AntragObj } from '../../api/models/Antrag/AntragsModel';
import { getCasePath } from '../../pages/AppRoutes';
import { useNavigate } from 'react-router-dom';
import { CaseDetailsModel } from '../../api/models/Case/CaseDetailsModel';

// @deprecated  TODO: do not use this anymore!
export function useElementNavigation() {
  const navigate = useNavigate();

  const navigateToElement = (
    element: CaseDetailsModel | AntragObj,
    replace?: boolean,
    state?: any
  ) => {
    if (element) {
      navigate(getCasePath(element.caseId), { replace, state });
    }
  };

  return { navigateToElement };
}
